// extracted by mini-css-extract-plugin
module.exports = {"iconList":"TypePicker_iconList__1ZSQF","iconListItem":"TypePicker_iconListItem__2OjLB"};